module.exports = __webpack_public_path__ + "img/automation2.e5e7502c.png";